import styled from 'styled-components';
export const SelectWrapper = styled.div `
  position: relative;
  min-height: 2.5rem;

  & > span {
    z-index: 1;
    position: absolute;
    right: 0rem;
    bottom: 0rem;
    pointer-events: none;
    transition: transform 0.3s ${({ opened }) => (opened ? 'ease-in' : 'ease-out')};
    ${({ opened }) => (opened ? 'transform: rotate(-180deg);' : '  transform: rotate(0deg);')}
  }

  &.disabled,
  &.disabled:active,
  &.disabled:hover {
    & > span {
      svg {
        fill: ${({ theme, readOnly }) => readOnly ? theme.colors.black : `rgba(${theme.colors.transparentBlack}, 0.26)`};
      }
    }
  }

  @media ${({ theme }) => theme.device.touch} {
    & > span {
      ${({ $forceCustom, multiple }) => `${!$forceCustom && multiple ? 'display: none' : ''}`};
    }
  }
`;
